import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  return (
    <div className="home-container">
      {/* HERO SECTION */}
      <header className="hero">
        <div className="logo-container">
          {/* Ensure 'abhikalp-logo.png' is inside 'public/images/' folder */}
          <img src="/images/abhikalp-logo.png" alt="Abhikalp Logo" className="hero-logo" />
        </div>
        
        <h1 className="hero-title">Strategic Clarity for Founders</h1>
        <p className="hero-sub">
          Legal risk management, contract strategy, and dispute resolution.<br />
          Built for business owners, not just lawyers.
        </p>

        <div className="hero-cta-group">
          <Link to="/services" className="btn btn-primary">View Services & Fees</Link>
          <Link to="/about" className="btn btn-secondary">Our Philosophy</Link>
        </div>
        
        <p className="location-note">Serving Mumbai, Thane, and Navi Mumbai.</p>
      </header>

      {/* VALUE PROPOSITION GRID */}
      <section className="topics-section">
        <h2 className="section-heading">What We Solve</h2>
        <div className="topics-grid">
          {['Contract Negotiations', 'Co-Founder Agreements', 'Dispute Resolution', 'Regulatory Compliance', 'IP Protection', 'Due Diligence'].map((topic, i) => (
            <div key={i} className="topic-card">
              <span className="check-icon">✓</span> {topic}
            </div>
          ))}
        </div>
      </section>

      {/* SERVICE TEASER */}
      <section className="services-teaser">
        <div className="teaser-card inhouse">
          <h3>In-House Risk Support</h3>
          <p>Prevent fires before they start. We act as your external General Counsel for contracts and strategy.</p>
          <Link to="/services" className="text-link">View Pricing →</Link>
        </div>
        <div className="teaser-card litigation">
          <h3>Litigation Support</h3>
          <p>Strategic oversight when you are forced into a legal battle. We manage the process and the lawyers.</p>
          <Link to="/services" className="text-link">View Pricing →</Link>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="bottom-cta">
        <h2>Ready to secure your business?</h2>
        <p>Get professional oversight before a small risk becomes a crisis.</p>
        <Link to="/support" className="btn btn-primary btn-large">Contact Us</Link>
      </section>
    </div>
  );
};

export default Home;